import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { gridSizeMdLg6, ROUTER_PATHS } from '@/shared';

import {
  CreateICEParams,
  useCreateICE,
  useUpdateICE,
} from '@/shared/actions/erp';
import {
  CustomTextField,
  SampleCheckbox,
  SingleFormBoxScene,
} from '@/shared/components/ui';
import {
  ICE,
} from '@/shared/interfaces/erp';
import { newICESchema } from '@/shared/utils';


export type SaveICEProps = {
  titlePage: string;
  editICE?: ICE;
};

export type SaveFormData = CreateICEParams & {};

const SaveICE: React.FC<SaveICEProps> = ({ titlePage, editICE }) => {
  const returnUrlICEPage = ROUTER_PATHS.administration.ICENav

  const navigate = useNavigate();
  const [shrink, setShrink] = useState(false);

  ///* global state ---------------------

  ///* mutations ---------------------
  const createICEMutation = useCreateICE({
    navigate,
    returnUrl: returnUrlICEPage,
  });
  const updateICEMutation = useUpdateICE({
    navigate,
    returnUrl: returnUrlICEPage,
  });

  ///* form ---------------------
  const form = useForm<SaveFormData>({
    resolver: yupResolver(newICESchema) as any,
  });
  const {
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = form;

 


  ///* handlers ---------------------
  const onSave = () => {
    if (!isValid) return;

    ///* edit
    if (editICE?.id_ice) {
      return updateICEMutation.mutate({
        id: editICE.id_ice,
        data: form.getValues(),
      });
    }

    ///* create
    return createICEMutation.mutate(form.getValues());
  };

  ///* effects ---------------------
  useEffect(() => {
    if (!editICE?.id_ice) return;
    setShrink(true);
    reset(editICE as any);
  }, []);

  return (
    <SingleFormBoxScene
      titlePage={titlePage}
      onCancel={() => {
        navigate(returnUrlICEPage);
      }}
      onSave={handleSubmit(onSave, err => {
        console.error(err);
      })}
    >
      <CustomTextField
        label="Nombre"
        name="nombre"
        control={form.control}
        defaultValue={form.getValues().nombre || ''}
        error={errors.nombre}
        helperText={errors.nombre?.message}
        shrink={shrink}
        size={gridSizeMdLg6}
      />
      <CustomTextField
        label="Código"
        name="codigo"
        control={form.control}
        defaultValue={form.getValues().codigo || ''}
        error={errors.codigo}
        helperText={errors.codigo?.message ?? ''}
        shrink={shrink}
        size={gridSizeMdLg6}
      />
      <CustomTextField
        label="SRI codigo"
        name="sri_codigo"
        control={form.control}
        defaultValue={form.getValues().sri_codigo || ''}
        error={errors.sri_codigo}
        helperText={errors.sri_codigo?.message ?? ''}
        shrink={shrink}
        size={gridSizeMdLg6}
      />
      <CustomTextField
  label="SRI codigo porcentaje"
  name="sri_codigo_porcentaje"
  control={form.control}
  defaultValue={form.getValues().sri_codigo_porcentaje || ''}
  error={errors.sri_codigo_porcentaje}
  helperText={errors.sri_codigo_porcentaje?.message ?? ''}
  shrink={shrink}
  size={gridSizeMdLg6}
/>
<CustomTextField
  label="porcentaje"
  name="porcentaje"
  control={form.control}
  defaultValue={form.getValues().porcentaje || ''}
  error={errors.porcentaje}
  helperText={errors.porcentaje?.message ?? ''}
  shrink={shrink}
  size={gridSizeMdLg6}
/>
   
      {/* ======== Autocomplete city ======== */}
      
      <SampleCheckbox
        label="Estado"
        name="estado"
        control={form.control}
        defaultValue={!!form.getValues().estado}
        isState
        size={gridSizeMdLg6}
      />
    </SingleFormBoxScene>
  );
};

export default SaveICE;